var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx } from '@emotion/core';
import React from 'react'; // @ts-ignore
// eslint-disable-next-line @typescript-eslint/camelcase

import { arrowDown_16, arrowUp_16 } from '@trustpilot/icons';
import isEqual from 'lodash/isEqual';
import { Button } from '../../../Button';
import { Button as FilterButton } from '../button';
import { applySearch, useToggle } from '../../../shared';
import { Link } from '../link';
import { useLocalization } from '../../../../localization';
import * as translations from '../../localization';
import { Wrapper } from './styled';
import { default as SelectItem } from './item';
import Dropdown from '../../dropdown';
/* eslint-disable @typescript-eslint/camelcase */

var DropdownHandle = function DropdownHandle(_a) {
  var toggled = _a.toggled,
      toggle = _a.toggle,
      loading = _a.loading,
      selectedAndAppliedItemsCount = _a.selectedAndAppliedItemsCount,
      multiple = _a.multiple,
      title = _a.title,
      id = _a.id;
  return jsx(FilterButton, {
    icon: toggled ? arrowUp_16 : arrowDown_16,
    onClick: toggle,
    loading: loading,
    active: selectedAndAppliedItemsCount > 0 || toggled,
    count: multiple ? selectedAndAppliedItemsCount : 0,
    id: id
  }, title);
};
/* eslint-enable */


var DropdownFooter = function DropdownFooter(_a) {
  var apply = _a.apply,
      currentItems = _a.currentItems,
      appliedItems = _a.appliedItems,
      strings = _a.strings,
      selectedItems = _a.selectedItems,
      clear = _a.clear,
      id = _a.id;
  return jsx(React.Fragment, null, jsx(Button, {
    "data-testid": "pl-header-filters-" + id + "-apply",
    size: "small",
    onClick: apply,
    disabled: isEqual(currentItems, appliedItems)
  }, strings.select.apply), selectedItems.length > 0 && jsx(Link, {
    id: "pl-header-filters-" + id + "-clear",
    secondary: true,
    inline: true,
    onClick: clear
  }, strings.select.clear));
};

function buildItems(children) {
  return React.Children.map(children, function (child) {
    return {
      checked: child.props.checked || false,
      content: child.props.children,
      value: child.props.value
    };
  });
}

var Select = React.forwardRef(function (_a, ref) {
  var _b = _a.children,
      children = _b === void 0 ? [] : _b,
      _c = _a.hasSearch,
      hasSearch = _c === void 0 ? false : _c,
      hidden = _a.hidden,
      id = _a.id,
      _d = _a.loading,
      loading = _d === void 0 ? false : _d,
      _e = _a.multiple,
      multiple = _e === void 0 ? false : _e,
      label = _a.label,
      onApply = _a.onApply,
      _f = _a.searchPlaceholder,
      searchPlaceholder = _f === void 0 ? '' : _f,
      updateCount = _a.updateCount;
  var strings = useLocalization(translations).strings;

  var _g = useToggle(false),
      toggled = _g[0],
      toggle = _g[1];

  var _h = React.useState(''),
      searchQuery = _h[0],
      setSearchQuery = _h[1];

  var _j = React.useState([]),
      currentItems = _j[0],
      setCurrentItems = _j[1];

  var _k = React.useState([]),
      appliedItems = _k[0],
      setAppliedItems = _k[1];

  var _l = React.useState(0),
      _count = _l[0],
      setCount = _l[1];

  function onSearchChange(event) {
    setSearchQuery(event.target.value);
  }

  function reset() {
    setSearchQuery('');
    setCurrentItems(appliedItems);
  }

  function apply() {
    var _a = currentItems.reduce(function (acc, item) {
      acc.items.push({
        value: item.value,
        checked: item.checked
      });

      if (item.checked) {
        acc.count += 1;
      }

      return acc;
    }, {
      items: [],
      count: 0
    }),
        items = _a.items,
        count = _a.count;

    if (toggled) {
      toggle();
    }

    setCount(count);
    setSearchQuery('');
    onApply({
      id: id,
      items: items
    });
  }

  function onItemClick(value) {
    var newItems = currentItems.map(function (item) {
      if (item.value === value) {
        return __assign(__assign({}, item), {
          checked: !item.checked
        });
      }

      return __assign(__assign({}, item), {
        checked: multiple ? item.checked : false
      });
    });
    setCurrentItems(newItems);
  }

  function clear() {
    var newItems = currentItems.map(function (item) {
      return __assign(__assign({}, item), {
        checked: false
      });
    });
    setCurrentItems(newItems);
    setSearchQuery('');

    if (toggled) {
      toggle();
    }

    setCount(0);
    onApply({
      id: id,
      items: newItems
    });
  }

  function handleClickOutside() {
    if (toggled) {
      toggle();
      reset();
    }
  }

  React.useEffect(function () {
    if (children) {
      var items = buildItems(children);

      if (!isEqual(items, currentItems) || !isEqual(items, appliedItems)) {
        var count_1 = items.reduce(function (acc, item) {
          return acc += item.checked ? 1 : 0;
        }, 0);
        setCurrentItems(items);
        setAppliedItems(items);
        setCount(count_1);
      }
    }
  }, [children]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(function () {
    if (updateCount) {
      updateCount();
    }
  }, [_count, updateCount]);
  React.useImperativeHandle(ref, function () {
    return {
      count: function count() {
        return _count;
      }
    };
  });
  var selectedItems = currentItems.filter(function (item) {
    return item.checked;
  });
  var selectedAndAppliedItems = appliedItems.filter(function (item) {
    return item.checked;
  });
  var selectedAndAppliedItemsCount = selectedAndAppliedItems.length;
  var filteredItems = applySearch(currentItems, searchQuery); // We just want to check if the item is present. isEqual is checking for the order too so we can't use it

  var isSelectAllChecked = filteredItems.reduce(function (acc, item) {
    var hasValue = selectedItems.some(function (i) {
      return i.value === item.value;
    });
    return acc && hasValue;
  }, true);
  var title = !multiple && selectedAndAppliedItemsCount === 1 ? selectedAndAppliedItems[0].content : label;

  var makeItems = function makeItems() {
    return React.Children.toArray(children).reduce(function (acc, child) {
      var filteredItem = filteredItems.find(function (item) {
        return child.props.value === item.value;
      });

      if (filteredItem) {
        acc.push(React.cloneElement(child, {
          onClick: onItemClick,
          checked: filteredItem.checked
        }));
      }

      return acc;
    }, []);
  };

  function selectAllFilteredItems() {
    var newItems = currentItems.map(function (item) {
      if (filteredItems.some(function (i) {
        return i.value === item.value;
      })) {
        return __assign(__assign({}, item), {
          checked: true
        });
      }

      return __assign(__assign({}, item), {
        checked: false
      });
    });
    setCurrentItems(newItems);
  }

  function clearAllFilteredItems() {
    var newItems = currentItems.map(function (item) {
      if (filteredItems.some(function (i) {
        return i.value === item.value;
      })) {
        return __assign(__assign({}, item), {
          checked: false
        });
      }

      return item;
    });
    setCurrentItems(newItems);
  }

  function onSelectAllChange() {
    if (isSelectAllChecked) {
      clearAllFilteredItems();
    } else {
      selectAllFilteredItems();
    }
  }

  if (hidden) {
    return null;
  }

  if (currentItems.length === 0 && !loading) {
    return null;
  }

  return jsx(Wrapper, null, jsx(Dropdown, {
    multiple: multiple,
    selectAll: {
      checked: isSelectAllChecked,
      indeterminate: selectedItems.length > 0 && selectedItems.length !== currentItems.length,
      onChange: onSelectAllChange,
      text: strings.select.selectAll
    },
    handle: jsx(DropdownHandle, {
      toggled: toggled,
      toggle: toggle,
      loading: loading,
      selectedAndAppliedItemsCount: selectedAndAppliedItemsCount,
      multiple: multiple,
      title: title,
      id: id
    }),
    footer: jsx(DropdownFooter, {
      apply: apply,
      currentItems: currentItems,
      appliedItems: appliedItems,
      strings: strings,
      selectedItems: selectedItems,
      clear: clear,
      id: id
    }),
    toggled: toggled,
    onOutsideClick: handleClickOutside,
    search: hasSearch ? {
      searchPlaceholder: searchPlaceholder,
      onSearchChange: onSearchChange,
      searchQuery: searchQuery
    } : undefined
  }, filteredItems.length > 0 ? makeItems() : [jsx(SelectItem, {
    key: "placeholder-select",
    isPlaceholder: true,
    value: ""
  }, strings.select.nomatch)]));
});
export default Select;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/select/select.js
// module id = 1038
// module chunks = 0